module.exports = __webpack_public_path__ + "img/fr.830ad970.png";